import { AgGridTable, AgGridTableRef } from '@shared/components/ui/AgGridTable';
import { ColDef } from 'ag-grid-community';
import React, { useCallback, useEffect, useRef } from 'react';
import { CourierFile } from '../../models';

interface CourierFilesAgGridTableProps {
  courierFiles: CourierFile[];
  columnDefs: ColDef[];
  isLoading?: boolean;
  isFetching?: boolean;
  sorting?: { field: string; direction: 'asc' | 'desc' } | null;
  onSortingChange?: (sorting: { field: string; direction: 'asc' | 'desc' } | null) => void;
  selectedFiles?: Set<number>;
  onSelectionChanged?: (selectedFiles: Set<number>) => void;
  onClearSelection?: () => void;
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
}

export const CourierFilesAgGridTable = React.memo(function CourierFilesAgGridTable({
  courierFiles,
  columnDefs,
  isLoading = false,
  isFetching = false,
  sorting,
  onSortingChange,
  selectedFiles,
  onSelectionChanged,
  fetchNextPage,
  hasNextPage = false,
  isFetchingNextPage = false,
}: CourierFilesAgGridTableProps) {
  const agGridRef = useRef<AgGridTableRef>(null);

  const clearSelectionUI = useCallback(() => {
    agGridRef.current?.deselectAll();
  }, []);

  const handleSelectionChanged = useCallback(
    (selectedRows: CourierFile[]) => {
      const selectedIds = new Set(selectedRows.map((file) => file.id));

      if (onSelectionChanged) {
        onSelectionChanged(selectedIds);
      }
    },
    [onSelectionChanged],
  );

  // Sincronizar selección con AG Grid (solo para limpiar selección)
  useEffect(() => {
    if (selectedFiles && selectedFiles.size === 0) {
      clearSelectionUI();
    }
  }, [selectedFiles, clearSelectionUI]);

  return (
    <div
      className={`w-full ${
        isFetching && !isFetchingNextPage ? 'opacity-50 pointer-events-none transition-opacity duration-200' : ''
      }`}
    >
      <AgGridTable
        ref={agGridRef}
        data={courierFiles}
        columnDefs={columnDefs}
        height="calc(100vh - 200px)"
        enableSelection={true}
        gridOptions={{}}
        isLoading={isLoading}
        rowHeight={56}
        sorting={sorting}
        onSortingChange={onSortingChange}
        onSelectionChanged={handleSelectionChanged}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
      />
    </div>
  );
});
